import { useLocation } from 'react-router';

import { isServerRendering } from 'src/App/services/environment';

export const useRedirectURL = () => {
  const { state } = useLocation();

  if (isServerRendering()) {
    return {
      origin: '',
      pathname: '',
      search: '',
    };
  }

  const searchParams = new URLSearchParams(window.location.search);

  if (state?.productId) {
    searchParams.set('productId', state?.productId);
  }

  return {
    origin: window.location?.origin,
    pathname: state?.pathname ?? window.location?.pathname,
    search: Boolean(searchParams.toString())
      ? `?${searchParams.toString()}`
      : '',
  };
};
